import { IconPropTypes } from '@/legacy/types';

const DoorClose = (props: IconPropTypes) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={props.width || 16}
			height={props.height || 16}
			fill='none'
			{...props}
		>
			<g
				fill={props.color || 'currentColor'}
				clipPath='url(#a)'
			>
				<path d='m1.167 8.667-.052-.003a.5.5 0 0 1 0-.995l.052-.002h6.5a.5.5 0 0 1 0 1h-6.5Z' />
				<path d='M4.02 11.02a.5.5 0 0 1-.669.035l-.038-.035-2.5-2.5-.034-.037a.5.5 0 0 1 .034-.67l2.5-2.5a.5.5 0 1 1 .707.707L1.874 8.167l2.146 2.146.035.038a.5.5 0 0 1-.035.67ZM10.667 14.09c0 .304.259.577.611.577h2.777a.595.595 0 0 0 .612-.577V2.244a.595.595 0 0 0-.612-.577h-2.777a.595.595 0 0 0-.611.577V14.09Zm-1-11.846c0-.886.736-1.577 1.611-1.577h2.777c.875 0 1.612.691 1.612 1.577V14.09c0 .885-.737 1.577-1.612 1.577h-2.777c-.875 0-1.611-.692-1.611-1.577V2.244Z' />
			</g>
			<defs>
				<clipPath id='a'>
					<path
						fill='#fff'
						d='M0 0h16v16H0z'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default DoorClose;
